import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=5709268e"
import script from "./NewDialog.vue?vue&type=script&lang=js"
export * from "./NewDialog.vue?vue&type=script&lang=js"
import style0 from "./NewDialog.vue?vue&type=style&index=0&id=5709268e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports